const initialMonthlyPlan = {
    monthlyplannermessages : {},
    monthlyplantitles: [],
    getmonthplanbydates : [],
};

const stateReducer = (Monthlyplan = initialMonthlyPlan, action) => {
    switch (action.type) {
        case 'GET_MONTHLY_PLANNER_TITLE':
            return {
                ...Monthlyplan, monthlyplantitles: action.payload.data
            };
        case 'GET_MONTHLY_PLANNER_BY_DATE':
          return {
              ...Monthlyplan, getmonthplanbydates: action.payload.data
          };
        case 'ADD_NEW_MONTHLY_PLAN':
            return {
                ...Monthlyplan, monthlyplannermessages: action.payload.data
        };
        case 'UPDATE_MONTHLY_PLAN':
            return {
                ...Monthlyplan, monthlyplannermessages: action.payload.data
            };
        case 'ADD_NEW_TODO':
            return {
                ...Monthlyplan, monthlyplannermessages: action.payload.data
            };
        case 'COMPLETED_TODO':
            return {
                ...Monthlyplan, monthlyplannermessages: action.payload.data
            };
        default:
            return Monthlyplan;
    }
}
export default stateReducer;